// extracted by mini-css-extract-plugin
module.exports = {"subtitleConfiguracao":"styles_subtitleConfiguracao__3TWVN","addLojasWrapper":"styles_addLojasWrapper__1Y74h","table":"styles_table__2xlb7"};